export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface EventRoute {
  id: string;
  name: string;
  subtitle: string;
  type: 'asfalto' | 'senderos';
  distance: string;
  elevation: string;
  difficulty: 'Moderado' | 'Desafiante' | 'Técnico';
  description: string;
  features: string[];
  mapUrl: string;
}

export interface CountdownData {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
}

export const EVENT_CONFIG = {
  name: 'Ibiza Bike Epic 2026',
  tagline: 'Balanced Ride Weekend',
  dates: {
    day1: '2026-10-31',
    day2: '2026-11-01',
    fullRange: '31 de Octubre y 1 de Noviembre, 2026',
  },
  location: 'Ibiza, Islas Baleares, España',
  registrationUrl: 'https://external-provider.com/subscribe/ibiza-bike-epic-2026',
  sustainability: {
    title: 'Sostenibilidad · Compromiso Real',
    description: 'Rendimiento y responsabilidad. En equilibrio. Organizar un evento de mountain bike y ciclismo en Ibiza deja huella. Queremos conocerla con datos y transparencia para proteger el entorno natural de la isla.',
    initiatives: [
      'Medición de huella de carbono del evento mountain bike con plan de reducción a cinco años.',
      'Gestión rigurosa de residuos hacia modelo Residuo Cero en todos los puntos del recorrido.',
      'Programa de impacto social positivo con la comunidad local de Ibiza.',
      'Actividades dirigidas a asociaciones deportivas y jóvenes ciclistas de la isla.',
    ],
  },
  routes: [
    {
      id: 'mtb-epic',
      name: 'Ruta Mountain Bike Ibiza (MTB)',
      subtitle: '1ª ETAPA – DIA 31 DE OCTUBRE DE 2026',
      type: 'senderos',
      distance: '111 KM',
      elevation: '2.500 m+',
      difficulty: 'Técnico',
      description: 'Senderos técnicos de mountain bike por los mejores trails de Ibiza con desniveles extremos. Tramos de pura adrenalina rodeados de naturaleza mediterránea. Descensos rápidos y desafiantes por paisajes únicos.',
      features: ['Salida: Puerto de Ibiza', 'Llegada: Sant Jordi', 'Hora salida: 8:00h', 'Senderos mountain bike técnicos', 'Trails naturales Ibiza'],
      mapUrl: 'https://www.google.com/maps/d/u/0/edit?mid=1d6z_RHg93rUm7V7-Ab7muoNs3P26zQI&usp=sharing',
    },
    {
      id: 'road-epic',
      name: 'Ruta Ciclismo Carretera Ibiza',
      subtitle: '2ª ETAPA – DIA 1 DE NOVIEMBRE DE 2026',
      type: 'asfalto',
      distance: '135 KM',
      elevation: '2.285 m+',
      difficulty: 'Desafiante',
      description: 'Recorridos fluidos de ciclismo de carretera por las mejores rutas de Ibiza con vistas espectaculares al Mediterráneo. Tramos que combinan exigencia técnica y resistencia por carreteras icónicas de la isla pitiusa.',
      features: ['Salida: Puerto de Ibiza', 'Llegada: Sant Jordi', 'Hora salida: 8:00h', 'Vistas panorámicas Mediterráneo', 'Carreteras icónicas Ibiza'],
      mapUrl: 'https://www.google.com/maps/d/u/0/edit?mid=1Z6t_5r8gZ3jzAwz3U2QMga-oqBnfpV8&usp=sharing',
    },
  ] as EventRoute[],
};

/**
 * Calcula el tiempo restante hasta la fecha del evento (31 de Octubre de 2026)
 */
export function calculateTimeRemaining(): CountdownData {
  const targetDate = new Date('2026-10-31T09:00:00').getTime();
  const now = new Date().getTime();
  const difference = targetDate - now;

  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isExpired: true,
    };
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((difference % (1000 * 60)) / 1000),
    isExpired: false,
  };
}
